import React, { useEffect, useState } from "react";
import {
  Paper,
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  TextField,
  Button,
  Box,
  Checkbox,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  AssetsChecklistApproveByID,
  assestChecklistApprove,
  getAssetsCheckListDetailById,
  getStageUpdate,
} from "../../../api/resignationCheckliistAssign";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
export default function AssetsForm({ latestStatus }) {
  const params = useParams();
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [assetDetail, setAssetDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hrData, setHrData] = useState([]);
  const [hrRemarks, setHrRemarks] = useState("");
  const [rID, setID] = useState({ resign_id: "", status: "" });
  const dispatch = useDispatch();
  console.log("kkoioio", location.state);
  const resg_id = location.state;
  const ResignationId = localStorage.getItem("ResignationId");

  useEffect(() => {
    if (location?.state?.status || params.status) {
      assetChecklistApproveById();
      getAssetChecklistDetails();
    } else {
      navigate("/resignation-request");
    }

    if (resg_id) {
      setID(resg_id);
    }
  }, []);
  async function getAssetChecklistDetails() {
    try {
      const { data } = await getAssetsCheckListDetailById(
        params.id,
        user.token
      );
      if (data.data.length === 0) {
        dispatch(showAlert(data.msg));
        callManualAssignAsset();
      } else {
        setAssetDetail([...data.data]);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const handleChange = (event) => {
    setHrRemarks(event.target.value);
  };

  async function assetChecklistApproveById() {
    try {
      const { data } = await AssetsChecklistApproveByID(params.id, user.token);
      if (data.data.length) {
        setHrData([...data.data]);
        setHrRemarks(data.data[0].hr_remarks);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    let assetData = "";
    let empData = {
      resg_id: rID.resign_id,
      emp_id: params.id,
      asset_id: assetDetail
        ?.map((el) => el.asset_id)
        .join(",")
        .toString(),
      hr_remarks: hrRemarks,
    };

    try {
      const { data } = await assestChecklistApprove(empData, user.token);
      dispatch(showAlert(data.data));
      navigate("/resignation-request");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const navigate = useNavigate();
  async function callManualAssignAsset() {
    try {
      const { data } = await getStageUpdate(
        { id: ResignationId, update: "asset" },
        user.token
      );
      navigate("/resignation-request");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return (
    <Paper sx={{ p: 3 }}>
      <Grid container spacing={2} alignItems="center">
        {assetDetail.map((p, i) =>
          p.category === "Laptop" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize" }}
                >
                  Laptop
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Monitor" name="Monitor">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="CPU"
                        name="cpu"
                        // value={p.cpu}
                        value="lenevo"
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="RAM"
                        name="ram"
                        // value={p.ram}
                        value="12"
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Storage"
                        name="storage"
                        // value={p.storage}
                        value="256Gb"
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : p.category === "Monitor" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize" }}
                >
                  Monitor
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Monitor" name="Monitor">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>

                    {/* <Grid item xs={2}>
                    <TextField
                      label="CPU"
                      name="cpu"
                      // value={p.cpu}
                      value="Len cpu"
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="RAM"
                      name="ram"
                      // value={p.ram}
                      value="6"
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                    </Grid>
                     <Grid item xs={2}>
                    <TextField
                      label="Storage"
                      name="storage"
                      // value={p.storage}
                      value="1TB"
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                  </Grid> */}
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : p.category === "Mobile" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize", p: 2 }}
                >
                  Mobile
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Mobile" name="Mobile">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        label="CPU"
                        name="cpu"
                        value={p.cpu}
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="RAM"
                        name="ram"
                        value={p.ram}
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Storage"
                        name="storage"
                        value={p.storage}
                        fullWidth
                        disabled
                        multiline
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : p.category === "Mouse" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize", p: 2 }}
                >
                  Mouse
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Mouse" name="Mouse">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>

                    {/* <Grid item xs={2}>
                  <TextField
                    label="CPU"
                    name="cpu"
                    value={p.cpu}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="RAM"
                    name="ram"
                    value={p.ram}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                  </Grid>
                   <Grid item xs={2}>
                  <TextField
                    label="Storage"
                    name="storage"
                    value={p.storage}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                </Grid> */}
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : p.category === "Keyboard" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize", p: 2 }}
                >
                  Keyboard
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Keyboard" name="Keyboard">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>

                    {/* <Grid item xs={2}>
                    <TextField
                      label="CPU"
                      name="cpu"
                      value={p.cpu}
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="RAM"
                      name="ram"
                      value={p.ram}
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                    </Grid>
                     <Grid item xs={2}>
                    <TextField
                      label="Storage"
                      name="storage"
                      value={p.storage}
                      fullWidth
                      disabled
                      multiline
                      sx={{ mt: 1 }}
                    />
                  </Grid> */}
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : p.category === "Charger" ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                border: 2,
                m: 2,
                boxShadow: 3,
                p: 3,
                borderColor: "primary.main",
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox defaultChecked disabled />}
                />
                <Typography
                  variant="subtitle "
                  sx={{ fontSize: "h6.fontSize", p: 2 }}
                >
                  Charger
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <RadioGroup row aria-label="Charger" name="Charger">
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                      <TextField
                        label="Model Name"
                        name="model_name"
                        value={p.item_name}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Model"
                        name="model"
                        value={p.model}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Assign Date"
                        name="assign_date"
                        value={formatDateToYYYYMMDD(p.assign_date)}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Serial Number"
                        name="serialnumber"
                        value={p.serialnumber}
                        fullWidth
                        multiline
                        disabled
                      />
                    </Grid>

                    {/* <Grid item xs={2}>
                  <TextField
                    label="CPU"
                    name="cpu"
                    value={p.cpu}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="RAM"
                    name="ram"
                    value={p.ram}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                  </Grid>
                   <Grid item xs={2}>
                  <TextField
                    label="Storage"
                    name="storage"
                    value={p.storage}
                    fullWidth
                    disabled
                    multiline
                    sx={{ mt: 1 }}
                  />
                </Grid> */}
                    <Grid item xs={3}>
                      <TextField
                        label="Status"
                        name="status"
                        value={p.status}
                        fullWidth
                        multiline
                        disabled
                        sx={{ mt: 1 }}
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          ) : null
        )}

        <Grid item xs={12}>
          <TextField
            rows={3}
            name="hr_remarks"
            label="Hr Remarks"
            value={hrRemarks}
            onChange={handleChange}
            sx={{ border: 1, borderRadius: 2 }}
            fullWidth
            multiline
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            columnGap: 1,
            ml: "auto",
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            disabled={loading}
            onClick={() => {
              navigate(-2);
              // navigate("/assets-checklist");
            }}
            className="blue-button"
          >
            CANCEL
          </Button>
          {latestStatus === "CREDENTIALS_CHECKLIST_APPROVED" && (
            <Button
              variant="contained"
              type="submit"
              style={{ padding: "5px 7px" }}
              className="blue-button"
              onClick={onSubmit}
            >
              SUBMIT
            </Button>
          )}
        </Box>
      </Grid>
    </Paper>
  );
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
